import React, { useState, useEffect, useContext } from "react";
import { ModalBody, Spinner } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { getApiService } from "../services/ApiService";
import { GetPayLoad } from "../services/PayLoadStorage";
import '../assets/css/Modal.css';
import { LanguageContext } from "../contexts/LanguageContext";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const SwitchToPaperModal = ({ handleCancelRequest, address, sendDataToParent, hidePaperOption }) => {

    const [isDisabled, setDisabled] = useState(false);
    const [isLoading, setLoading] = useState(false);
    
    const Payload = GetPayLoad('PayLoad');
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region
    };

    const { pageContent } = useContext(LanguageContext);
    const [billingContent, setBillingContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);

    useEffect(() => {
        if (pageContent?.billing) {
            setBillingContent(pageContent.billing);
        }
        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }
    }, [pageContent]);

    const handleSwitchToPaper = (e) => {
        setDisabled(true);
        setLoading(true);
        e.preventDefault();
        const targetActivateAccountUrl = process.env.REACT_APP_API_SWITCH_TO_EBILL_ENDPOINT;
        getApiService(baseUrl, targetActivateAccountUrl, { cim: Payload?.cim, action: 'paper' }, headers)
            .then((response) => {
                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setDisabled(false);
                    sendDataToParent(genericContent?.service_post_error, 'tab3', 'error');
                }else{
                    handleCancelRequest();
                    sendDataToParent(billingContent?.billing_switch_billing_preference_success_msg, 'tab3', 'success');
                }
            })
            .catch(error => {
                setLoading(false);
                setDisabled(false);
                sendDataToParent(genericContent?.service_post_error, 'tab3', 'error');
            });
    }

   
    const switchToPaperDisabledContent = billingContent?.billing_switch_to_paper_disabled??"";
    let modifiedSwitchToPaperDisabledContent = switchToPaperDisabledContent;
   
    
 
    return (
        <>
            <Modal.Header className={`billing-header d-xl-flex d-md-flex pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
                <div></div>
            </Modal.Header>

            <ModalBody className="switchtopaper">
                {!hidePaperOption && (
                <div>
                    <div tabIndex={0} aria-atomic="true">
                        <p className="lh-base">
                            {billingContent?.billing_switch_billing_preference_confirmation_popup_msg}
                            <span className="fw-semibold"> {billingContent?.billing_switch_billing_preference_paper_text}</span>
                            <br />
                        </p>
                        <p className="lh-base">
                            {billingContent?.billing_switch_billing_preference_confirmation_popup_msg1}<br></br>
                            <span className=""> {address}</span>
                        </p>
                    </div>
                </div>
                )}

                {hidePaperOption && (
                <>
                <div tabIndex={0}>{parse(modifiedSwitchToPaperDisabledContent)}</div>
                </>
                )}

                <div className="col-12">
                    {!hidePaperOption && (
                        <>
                        {/* Responsive button order for Q5 carrier */}
                        {Payload?.owning_carrier === 'Q5' ? (
                            <>
                                {/* Mobile/Tablet: Switch to Paper top, Cancel bottom */}
                                <div className="q5-switch-mobile-btns d-block d-lg-none">
                                    <button
                                        type="submit"
                                        aria-label="submit"
                                        className="btn btn-secondary btn-lg mt-4 col-5 switchtopaperbtn"
                                        onClick={handleSwitchToPaper}
                                        disabled={isDisabled}
                                    >
                                        {billingContent?.billing_switch_to_paper_text}
                                    </button>
                                    
                                    <button
                                        aria-label="Cancel"
                                        className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5 cancelrequestbtn"
                                        onClick={handleCancelRequest}
                                    >
                                        {billingContent?.billing_switch_billing_preference_cancel_req_text}
                                    </button>
                                </div>
                                {/* Large screens: Cancel first, Switch to Paper second */}
                                <div className="q5-switch-desktop-btns d-none d-lg-flex">
                                    <button
                                        aria-label="Cancel"
                                        className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5 cancelrequestbtn"
                                        onClick={handleCancelRequest}
                                    >
                                        {billingContent?.billing_switch_billing_preference_cancel_req_text}
                                    </button>
                                    <button
                                        type="submit"
                                        aria-label="submit"
                                        className="btn btn-secondary btn-lg mt-4 col-5 switchtopaperbtn"
                                        onClick={handleSwitchToPaper}
                                        disabled={isDisabled}
                                    >
                                        {billingContent?.billing_switch_to_paper_text}
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <button
                                    aria-label="Cancel"
                                    className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5 cancelrequestbtn"
                                    onClick={handleCancelRequest}
                                >
                                    {billingContent?.billing_switch_billing_preference_cancel_req_text}
                                </button>
                                <button
                                    type="submit"
                                    aria-label="submit"
                                    className="btn btn-secondary btn-lg mt-4 col-5 switchtopaperbtn"
                                    onClick={handleSwitchToPaper}
                                    disabled={isDisabled}
                                >
                                    {billingContent?.billing_switch_to_paper_text}
                                </button>
                            </>
                        )}
                        </>
                    )}
                    {isLoading && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit', float: 'right', paddingTop: '25px' }}>
                            <Spinner animation="border" role="status" ></Spinner>
                            <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                        </div>
                    )}
                </div>
            </ModalBody>
        </>
    )
}

export default SwitchToPaperModal;